import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dilw26syov: FaireBrandEntity = {
  token: "b_dilw26syov",
  type: "brand",
  name: "TIMING",
  avatarUrl:
    "https://cdn.faire.com/fastly/b7c793fe365b7f88468a870ed7ed61fcb31111d01166f75788aa990b0234fe3a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/311b109612ac1184928836ce14783e2808472110744aca962fde717669319e92.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b7c793fe365b7f88468a870ed7ed61fcb31111d01166f75788aa990b0234fe3a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/311b109612ac1184928836ce14783e2808472110744aca962fde717669319e92.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.4,
  reviewCount: 10,
  isInsider: true,
  description:
    "Established in 1989 in sunny Los Angeles, Timing has continues to grow with her wardrobe.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:23.034Z",
    importedBy: "entity-db-cli",
  },
};
